import { ROLES } from '../constants/roles';
import { useCurrentRoles } from './use-current-roles';

/**
 * Satıcı modüllerini (Ürün, Envanter, Sipariş, Depo, Mağazam) görebilir mi. Sunucu hiyerarşisi
 * istemciye gelmediği için ADMIN burada satıcı sayılır.
 */
export const isSellerRoleSet = (roles: Set<string>): boolean =>
  roles.has(ROLES.SELLER) || roles.has(ROLES.ADMIN);

export const useIsSeller = (): boolean => {
  const { roles } = useCurrentRoles();
  return isSellerRoleSet(roles);
};
